export default __webpack_public_path__ + "static/dollywood-5c0e3691a6585e819a9b86a80c3a2321.png";